import React, { FunctionComponent, ReactNode } from 'react'
import styled from '@emotion/styled'
import { Space } from 'antd'

const StyledContainer = styled.div`
  border-radius: 5px;
  background-color: #262626 !important;
  padding: 5px;
  width: 100%;
  display: flex;
`

interface IProps {
  children: ReactNode | ReactNode[]
}

const MapClickOptionsContainer: FunctionComponent<any> = (props: IProps) => {
  return (
    <StyledContainer>
      <Space direction={'vertical'} style={{ flex: 1 }}>
        {props.children}
      </Space>
    </StyledContainer>
  )
}

export default MapClickOptionsContainer
